import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/admin/layout/AdminSidebar";
import { useAuth } from "../hooks/pages/useAuth";

const AdminLayout = () => {
    // 📌 Quản lý trạng thái mở/đóng Sidebar
    const [sidebarOpen, setSidebarOpen] = useState(false);

    // 📌 Quản lý chế độ Dark Mode
    const [darkMode, setDarkMode] = useState(false);

    // 📌 Lấy thông tin người dùng
    const { user, loading } = useAuth();

    // 📌 Khi mount: load trạng thái dark mode
    useEffect(() => {
        const savedMode = localStorage.getItem("darkMode") === "true";
        setDarkMode(savedMode);
        if (savedMode) document.documentElement.classList.add("dark");
    }, []);

    // 🔹 Trạng thái loading
    if (loading) return <div className="p-6 text-center">Đang tải...</div>;

    // 🔹 Không có user
    if (!user) {
        return (
            <div className="p-6 text-center text-red-600 text-xl">
                Bạn cần đăng nhập để truy cập trang này.
            </div>
        );
    }

    // 🔹 Sai quyền
    if (user.role !== "admin" && user.role !== "staff") {
        return (
            <div className="p-6 text-center text-red-600 text-xl">
                Bạn không có quyền truy cập trang này.
            </div>
        );
    }

    // 📌 Toggle Dark Mode
    const toggleDarkMode = () => {
        const newMode = !darkMode;
        setDarkMode(newMode);
        localStorage.setItem("darkMode", newMode);
        document.documentElement.classList.toggle("dark", newMode);
    };

    return (
        <div className="relative min-h-screen bg-gray-100 dark:bg-gray-900">
            {/* Header */}
            <div className="p-4 flex items-center justify-between bg-white dark:bg-gray-800 shadow sticky top-0 z-40">
                <div className="flex items-center gap-3">
                    {/* Nút mở sidebar (mobile) */}
                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="text-gray-600 dark:text-orange-400 hover:text-blue-600 dark:hover:text-orange-500 text-2xl"
                    >
                        &#9776;
                    </button>

                    {/* Logo / Tên hệ thống */}
                    <div className="text-2xl font-serif font-bold tracking-widest uppercase">
                        <span className="text-[#c9a063]">Mỹ Diệp</span> <span className="text-[#0c2c4d] dark:text-white">Property</span>
                    </div>
                </div>

                {/* Toggle Dark Mode */}
                <button
                    onClick={toggleDarkMode}
                    className="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                >
                    {darkMode ? "☀️ Sáng" : "🌙 Tối"}
                </button>
            </div>

            {/* Sidebar */}
            <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            {/* Overlay (ẩn sidebar khi click ra ngoài) */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-40"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Nội dung chính */}
            <main className="p-4 z-0 relative text-gray-900 dark:text-gray-100">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
